import React from 'react';

interface RemainingBalanceProps {
    remainingBalance: number;
    subscriptionPlan: string | null;
}

const RemainingBalance: React.FC<RemainingBalanceProps> = ({
    remainingBalance,
    subscriptionPlan
}) => {
    if (subscriptionPlan !== 'hybrid') {
        return null;
    }

    const formattedBalance = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(remainingBalance);

    return (
        <div className="bg-neutral-200 dark:bg-neutral-700 rounded-lg p-4">
            <div className="flex justify-between items-center">
                <span className="text-neutral-900 dark:text-white">Remaining Balance</span>
                <span className={`text-sm ${remainingBalance < 0 ? 'text-red-500' : 'text-green-500'}`}>
                    {formattedBalance}
                </span>
            </div>
        </div>
    );
};

export default RemainingBalance;